import React from 'react';

import Layout from '../layouts/LoginLayout';
import { ForgotPasswordForm } from '@repo/auth/components/ForgotPasswordForm';

const passwordLoginEndpoint = import.meta.env.VITE_PASSWORD_LOGIN_ENDPOINT!;

const ForgotPasswordPage = () => {
  return (
    <Layout>
      <ForgotPasswordForm passwordLoginEndpoint={passwordLoginEndpoint} />
    </Layout>
  );
};

export default ForgotPasswordPage;
